import React from 'react';
import {
    AddMemberForm as StyledForm,
    Input,
    Button,
    Error
} from '../../styles/ProjectMembers.styles';

const AddMemberForm = ({ email, loading, error, onEmailChange, onSubmit }) => (
    <>
        <StyledForm onSubmit={onSubmit}>
            <Input
                type="email"
                placeholder="Add member by email"
                value={email}
                onChange={(e) => onEmailChange(e.target.value)}
            />
            <Button type="submit" disabled={loading}>
                {loading ? 'Adding...' : 'Add'}
            </Button>
        </StyledForm>
        {error && <Error>{error}</Error>}
    </>
);

export default AddMemberForm;